/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Reset_Credentials_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to reset credentials. Please try again." |
*
* @param {Members_Reset_Credentials_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_reset_credentials_error = /** @type {((inputs?: Members_Reset_Credentials_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Reset_Credentials_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Zurücksetzen der Anmeldedaten. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to reset credentials. Please try again.")
});